import { jsx } from "react/jsx-runtime";
import { forwardRef } from "react";
export default forwardRef((props, ref) => jsx("svg", {
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref,
    ...props,
    dangerouslySetInnerHTML: { __html: '<path fill-rule="evenodd" clip-rule="evenodd" d="M18.808 17.432a1.333 1.333 0 0 0 1.19-1.326V14.44h2v-4h-2V8.774a1.333 1.333 0 0 0-1.334-1.333H8.817l9.99 9.99ZM6.696 7.44H3.342A1.341 1.341 0 0 0 2 8.774v7.324a1.342 1.342 0 0 0 1.333 1.341h13.361L6.696 7.441Z" fill="#CECECE"/> <path fill-rule="evenodd" clip-rule="evenodd" d="M2.757 4.52a.734.734 0 0 1 1.038 0L18.08 18.802a.734.734 0 0 1-1.038 1.038L2.757 5.557a.734.734 0 0 1 0-1.038Z" fill="#BD3D3A"/>' }
  })
);